export default "__VITE_ASSET__mxlmTDjQ__"